import {
  JOB_STATUS_CODE,
  LOCATION_TYPES_CODE,
  ENQUIRY_STATUS_CODE
} from 'redux/lodgeEnquiry/types';

export const workPlaceLocItems: any[] = [
  {
    id: 'road',
    value: 'Road',
    label: 'Road'
  },
  {
    id: 'footpath',
    value: 'Footpath',
    label: 'Footpath'
  },
  {
    id: 'nature-strip',
    value: 'Nature Strip',
    label: 'Nature strip'
  },
  {
    id: 'private',
    value: 'Private property',
    label: 'Private property'
  }
];

export const getJobStatusCodeMsg = (code: string) => {
  switch (code) {
    case JOB_STATUS_CODE.CREATED:
    case JOB_STATUS_CODE.WAITING:
      return 'Waiting';
    case JOB_STATUS_CODE.COMPLETED:
      return 'Responded';
    case JOB_STATUS_CODE.TIMEDOUT:
    case JOB_STATUS_CODE.FAILED:
      return 'Failed';
    default:
      break;
  }
};

export const getResponsesReceivedCount = (referrals: any) => {
  if (Array.isArray(referrals) && referrals.length > 0) {
    const received = referrals.filter(
      (r) => r.status === JOB_STATUS_CODE.COMPLETED
    );
    return { receivedCount: received.length, totalCount: referrals.length };
  }

  return { receivedCount: 0, totalCount: 0 };
};

export const getEnquiryStatusCodeMsg = (code: string) => {
  switch (code) {
    case ENQUIRY_STATUS_CODE.WAITING:
      return 'Waiting for responses';
    case ENQUIRY_STATUS_CODE.ALL_RECEIVED:
      return 'All Received';
    case ENQUIRY_STATUS_CODE.EXPIRED:
      return 'Expired';
    default:
      return code;
  }
};

export const getLocationTypesCodeMsg = (code: string) => {
  switch (code) {
    case LOCATION_TYPES_CODE.ROAD:
      return 'Road reserve';
    case LOCATION_TYPES_CODE.PRIVATE:
      return 'Private property';
    default:
      break;
  }
};

export const getActivityTypesCodeMsg = (
  code: string,
  designAct: any,
  excavationAct: any,
  isPlanningJob: boolean
) => {
  if (Array.isArray(designAct) && Array.isArray(excavationAct)) {
    const foundDesignAct = designAct.find((act: any) => act.code === code);
    if (foundDesignAct?.label && isPlanningJob) {
      return `Design - ${foundDesignAct.label.toLowerCase()}`;
    }
    const foundExcavationAct = excavationAct.find(
      (act: any) => act.code === code
    );
    if (foundExcavationAct?.label && !isPlanningJob) {
      return `Excavation - ${foundExcavationAct.label.toLowerCase()}`;
    }
  }

  return '';
};

export const NEW_ENQUIRY_DESCRIPTION =
  'Look for emails from these asset owners before you start work';
export const NEW_ENQUIRY_TITLE = 'What happens next?';

export const PDF_DOWNLOAD_SUPPORTED_EXTENSIONS = [
  'png',
  'bmp',
  'gif',
  'jpg',
  'svg',
  'tiff',
  'tif',
  'jpeg',
  'doc',
  'pdf'
];

export const RETIRED_ACTIVITY_TYPES = ['SUBDIVISION'];
